import React from "react";
import TeamCard from "../components/TeamCard";
import ImageGallery from "../components/ImageGallery";
const About = () => {
  const images = [
    "https://flowbite.s3.amazonaws.com/docs/gallery/masonry/image-6.jpg",
    "https://flowbite.s3.amazonaws.com/docs/gallery/masonry/image-7.jpg",
    "https://flowbite.s3.amazonaws.com/docs/gallery/masonry/image-9.jpg",
    "https://flowbite.s3.amazonaws.com/docs/gallery/masonry/image-8.jpg",
    "https://flowbite.s3.amazonaws.com/docs/gallery/masonry/image-9.jpg",
    "https://flowbite.s3.amazonaws.com/docs/gallery/masonry/image-6.jpg",
    "https://flowbite.s3.amazonaws.com/docs/gallery/masonry/image-11.jpg",
    "https://flowbite.s3.amazonaws.com/docs/gallery/masonry/image-7.jpg",
    "https://flowbite.s3.amazonaws.com/docs/gallery/masonry/image-8.jpg",
    "https://flowbite.s3.amazonaws.com/docs/gallery/masonry/image-10.jpg",
    "https://flowbite.s3.amazonaws.com/docs/gallery/masonry/image-11.jpg",
    "https://flowbite.s3.amazonaws.com/docs/gallery/masonry/image-10.jpg",
  ];
  return (
    <div className="min-h-screen bg-white px-4 xl:px-0 py-12 sm:py-20">
      {/* first section */}
      <section className="container mx-auto h-max md:h-96 mt-0 sm:mt-12 mb-0 sm:mb-24 flex flex-col gap-4 md:flex-row md:justify-between  ">
        <div className="w-full md:w-1/2 lg:w-3/4 xl:w-[672px]">
          <h1 className="text-3xl md:text-5xl lg:text-7xl mb-4 md:mb-8">
            We’re changing the <br /> way people connect
          </h1>
          <p className="">
            Cupidatat minim id magna ipsum sint dolor qui. Sunt sit in quis
            cupidatat mollit aute velit. Et labore commodo nulla aliqua proident
            mollit ullamco exercitation tempor. Sint aliqua anim nulla sunt
            mollit id pariatur in voluptate cillum. Eu voluptate tempor esse
            minim amet fugiat veniam occaecat aliqua.
          </p>
        </div>
        <ImageGallery images={images} />
      </section>

      {/* second section */}
      <section className="container mx-auto mt-8 sm:mt-12 md:mt-40 mb-0 sm:mb-24 flex flex-col gap-4 md:gap-0 md:flex-row md:justify-between items-center">
        <div className="w-full md:w-1/2">
          <h1 className="text-3xl md:text-5xl mb-4 md:mb-8">Our mission</h1>
          <p className="mb-4 md:mb-8">
            Aliquet nec orci mattis amet quisque ullamcorper neque, nibh sem. At
            arcu, sit dui mi, nibh dui, diam eget aliquam. Quisque id at vitae
            feugiat egestas ac. Diam nulla orci at in viverra scelerisque eget.
            Eleifend egestas fringilla sapien.
          </p>
          <p className="text-sm mb-4 md:mb-8">
            Faucibus commodo massa rhoncus, volutpat. Dignissim sed eget risus
            enim. Mattis mauris semper sed amet vitae sed turpis id. Id dolor
            praesent donec est. Odio penatibus risus viverra tellus varius sit
            neque erat velit. Faucibus commodo massa rhoncus, volutpat.
            Dignissim sed eget risus enim. Mattis mauris semper sed amet vitae
            sed turpis id.
          </p>
        </div>
        <div className="w-full md:w-1/2 flex justify-center">
          <div className="flex md:flex-col md:items-start gap-8 flex-wrap justify-center">
            <div>
              <h1 className="text-3xl md:text-5xl">44 million</h1>
              <p>Transactions every 24 hours</p>
            </div>
            <div>
              <h1 className="text-3xl md:text-5xl">$119 trillion</h1>
              <p>Assets under holding</p>
            </div>
            <div>
              <h1 className="text-3xl md:text-5xl">46,000</h1>
              <p>New users annually</p>
            </div>
          </div>
        </div>
      </section>

      {/* image section */}
      <section className="w-full my-8 md:my-24">
        <div className="container mx-auto">
          <img
            className="w-full h-auto md:h-[420px] object-contain md:object-cover object-right-bottom rounded-xl"
            src="https://images.unsplash.com/photo-1529156069898-49953e39b3ac?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2832&q=80"
            alt=""
          />
        </div>
      </section>

      {/* Fourth Section */}
      <section className="container mx-auto w-full my-8 md:my-24">
        <div className="w-full md:w-1/2">
          <h1 className="text-3xl md:text-5xl mb-4 md:mb-8">Our values</h1>
          <p>
            Lorem ipsum dolor sit amet consect adipisicing elit. Possimus magnam
            voluptatum cupiditate veritatis in accusamus quisquam.
          </p>
        </div>
        <div className="py-0 md:py-8">
          <ul className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-6">
            <li className="mt-8 h-auto md:h-48 rounded-lg flex flex-col gap-2 justify-center">
              <h4 className="font-bold text-[16px]">Be world-class</h4>
              <p className="text-[16px]">
                Aut illo quae. Ut et harum ea animi natus. Culpa maiores et sed
                sint et magnam exercitationem quia. Ullam voluptas nihil vitae
                dicta molestiae et. Aliquid velit porro vero.
              </p>
            </li>
            <li className="mt-8 h-auto md:h-48 rounded-lg flex flex-col gap-2 justify-center">
              <h4 className="font-bold text-[16px]">
                Share everything you know
              </h4>
              <p className="text-[16px]">
                Mollitia delectus a omnis. Quae velit aliquid. Qui nulla maxime
                adipisci illo id molestiae. Cumque cum ut minus rerum architecto
                magnam consequatur. Quia quaerat minima.
              </p>
            </li>
            <li className="mt-8 h-auto md:h-48 rounded-lg flex flex-col gap-2 justify-center">
              <h4 className="font-bold text-[16px]">Stay curious</h4>
              <p className="text-[16px]">
                Aut illo quae. Ut et harum ea animi natus. Culpa maiores et sed
                sint et magnam exercitationem quia. Ullam voluptas nihil vitae
                dicta molestiae et. Aliquid velit porro vero.
              </p>
            </li>
            <li className="mt-8 h-auto md:h-48 rounded-lg flex flex-col gap-2 justify-center">
              <h4 className="font-bold text-[16px]">Practice consistently</h4>
              <p className="text-[16px]">
                Mollitia delectus a omnis. Quae velit aliquid. Qui nulla maxime
                adipisci illo id molestiae. Cumque cum ut minus rerum architecto
                magnam consequatur. Quia quaerat minima.
              </p>
            </li>
            <li className="mt-8 h-auto md:h-48 rounded-lg flex flex-col gap-2 justify-center">
              <h4 className="font-bold text-[16px]">Build community</h4>
              <p className="text-[16px]">
                Aut illo quae. Ut et harum ea animi natus. Culpa maiores et sed
                sint et magnam exercitationem quia. Ullam voluptas nihil vitae
                dicta molestiae et. Aliquid velit porro vero.
              </p>
            </li>
            <li className="mt-8 h-auto md:h-48 rounded-lg flex flex-col gap-2 justify-center">
              <h4 className="font-bold text-[16px]">Embrace challenges</h4>
              <p className="text-[16px]">
                Mollitia delectus a omnis. Quae velit aliquid. Qui nulla maxime
                adipisci illo id molestiae. Cumque cum ut minus rerum architecto
                magnam consequatur. Quia quaerat minima.
              </p>
            </li>
          </ul>
        </div>
      </section>

      {/* Trusted Brands Section */}
      <section className="my-4 md:my-24 trusted-brands">
        <h2 className="mb-8 md:mb-12 title">
          Trusted by the world’s most innovative teams
        </h2>
        <div className="container mx-auto brand-grid">
          <div className="brand-item">
            <img
              src="https://tailwindcss.com/plus-assets/img/logos/158x48/transistor-logo-gray-900.svg"
              alt="Transistor"
            ></img>
          </div>
          <div className="brand-item">
            <img
              src="https://tailwindcss.com/plus-assets/img/logos/158x48/reform-logo-gray-900.svg"
              alt="Reform"
            ></img>
          </div>
          <div className="brand-item">
            <img
              src="https://tailwindcss.com/plus-assets/img/logos/158x48/tuple-logo-gray-900.svg"
              alt="Tuple"
            ></img>
          </div>
          <div className="brand-item">
            <img
              src="https://tailwindcss.com/plus-assets/img/logos/158x48/savvycal-logo-gray-900.svg"
              alt="SavvyCal"
            ></img>
          </div>
          <div className="brand-item">
            <img
              src="https://tailwindcss.com/plus-assets/img/logos/158x48/statamic-logo-gray-900.svg"
              alt="Statamic"
            ></img>
          </div>
        </div>
      </section>

      {/* Sixth Section */}
      <section className="container mx-auto w-full my-4 md:my-24">
        <div className="w-full md:w-1/2">
          <h1 className="text-3xl md:text-5xl mb-4 md:mb-8">Our team</h1>
          <p>
            We’re a dynamic group of individuals who are passionate about what
            we do and dedicated to delivering the best results for our clients.
          </p>
        </div>
        <div className="py-8">
          <ul className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-6 gap-3 md:gap-6">
            <li className="mt-8 h-auto md:h-48 rounded-lg flex flex-col gap-2 justify-center">
              <TeamCard
                image="https://images.unsplash.com/photo-1519244703995-f4e0f30006d5?ixlib=rb-=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=8&w=1024&h=1024&q=80"
                name="Michael Foster"
                position="Co-Founder / CTO"
              />
            </li>
            <li className="mt-8 h-auto md:h-48 rounded-lg flex flex-col gap-2 justify-center">
              <TeamCard
                image="https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?ixlib=rb-=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=8&w=1024&h=1024&q=80"
                name="Dries Vincent"
                position="Business Relations"
              />
            </li>
            <li className="mt-8 h-auto md:h-48 rounded-lg flex flex-col gap-2 justify-center">
              <TeamCard
                image="https://images.unsplash.com/photo-1517841905240-472988babdf9?ixlib=rb-=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=8&w=1024&h=1024&q=80"
                name="Lindsay Walton"
                position="Frontend Developer"
              />
            </li>
            <li className="mt-8 h-auto md:h-48 rounded-lg flex flex-col gap-2 justify-center">
              <TeamCard
                image="https://images.unsplash.com/photo-1519244703995-f4e0f30006d5?ixlib=rb-=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=8&w=1024&h=1024&q=80"
                name="Michael Foster"
                position="Co-Founder / CTO"
              />
            </li>
            <li className="mt-8 h-auto md:h-48 rounded-lg flex flex-col gap-2 justify-center">
              <TeamCard
                image="https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?ixlib=rb-=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=8&w=1024&h=1024&q=80"
                name="Dries Vincent"
                position="Business Relations"
              />
            </li>
            <li className="mt-8 h-auto md:h-48 rounded-lg flex flex-col gap-2 justify-center">
              <TeamCard
                image="https://images.unsplash.com/photo-1517841905240-472988babdf9?ixlib=rb-=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=8&w=1024&h=1024&q=80"
                name="Lindsay Walton"
                position="Frontend Developer"
              />
            </li>
            <li className="mt-8 h-auto md:h-48 rounded-lg flex flex-col gap-2 justify-center">
              <TeamCard
                image="https://images.unsplash.com/photo-1519244703995-f4e0f30006d5?ixlib=rb-=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=8&w=1024&h=1024&q=80"
                name="Michael Foster"
                position="Co-Founder / CTO"
              />
            </li>
            <li className="mt-8 h-auto md:h-48 rounded-lg flex flex-col gap-2 justify-center">
              <TeamCard
                image="https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?ixlib=rb-=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=8&w=1024&h=1024&q=80"
                name="Dries Vincent"
                position="Business Relations"
              />
            </li>
            <li className="mt-8 h-auto md:h-48 rounded-lg flex flex-col gap-2 justify-center">
              <TeamCard
                image="https://images.unsplash.com/photo-1517841905240-472988babdf9?ixlib=rb-=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=8&w=1024&h=1024&q=80"
                name="Lindsay Walton"
                position="Frontend Developer"
              />
            </li>
            <li className="mt-8 h-auto md:h-48 rounded-lg flex flex-col gap-2 justify-center">
              <TeamCard
                image="https://images.unsplash.com/photo-1519244703995-f4e0f30006d5?ixlib=rb-=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=8&w=1024&h=1024&q=80"
                name="Michael Foster"
                position="Co-Founder / CTO"
              />
            </li>
            <li className="mt-8 h-auto md:h-48 rounded-lg flex flex-col gap-2 justify-center">
              <TeamCard
                image="https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?ixlib=rb-=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=8&w=1024&h=1024&q=80"
                name="Dries Vincent"
                position="Business Relations"
              />
            </li>
            <li className="mt-8 h-auto md:h-48 rounded-lg flex flex-col gap-2 justify-center">
              <TeamCard
                image="https://images.unsplash.com/photo-1517841905240-472988babdf9?ixlib=rb-=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=8&w=1024&h=1024&q=80"
                name="Lindsay Walton"
                position="Frontend Developer"
              />
            </li>
          </ul>
        </div>
      </section>
    </div>
  );
};

export default About;
